import {debounce as _debounce} from 'lodash';

import {DEFAULT_GRAPHQL_DEBOUNCE_DELAY} from '@constants/variables';

export const createGraphqlDebouncedFetch = (fetchCallback) => (
    _debounce(fetchCallback, DEFAULT_GRAPHQL_DEBOUNCE_DELAY)
);

export const cancelGraphqlDebouncedFetches = (debouncedFetches) => {
    debouncedFetches.forEach(debouncedFetch => debouncedFetch?.cancel?.());
};
